import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Single } from "../sites/";
import { Lead } from "@cs125/gatsby-theme-cs125/src/material-ui";
import { LoginButton } from "@cs125/gatsby-theme-cs125/src/react-google-login";
import { WithUser } from "../components/WithUser";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Single;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p><a parentName="p" {...{
        "href": "https://www.npmjs.com/package/@cs125/react-google-login"
      }}><img parentName="a" {...{
          "src": "https://img.shields.io/npm/v/@cs125/react-google-login",
          "alt": "npm"
        }}></img></a>{`
`}<a parentName="p" {...{
        "href": "https://opensource.org/licenses/MIT"
      }}><img parentName="a" {...{
          "src": "https://img.shields.io/badge/License-MIT-yellow.svg",
          "alt": "License: MIT"
        }}></img></a></p>
    <pre><code parentName="pre" {...{
        "className": "language-sh",
        "metastring": "id=install",
        "id": "install"
      }}>{`npm i @cs125/react-google-login
`}</code></pre>
    <Lead mdxType="Lead">
      <p>{`React Typescript support for `}<a parentName="p" {...{
          "href": "https://developers.google.com/identity/sign-in/web/sign-in"
        }}>{`Google Sign-in`}</a>{`.`}</p>
    </Lead>
    <h2>{`Use`}</h2>
    <p>{`Visit the `}<a parentName="p" {...{
        "href": "https://github.com/cs125-illinois/react-google-login"
      }}>{`documentation here`}</a>{`.`}</p>
    <h2>{`Demo`}</h2>
    <p>{`The login button below will open the standard Google Sign-in dialog.
Once you are signed in, your name, email address, photo, and a login token will be displayed.`}</p>
    <div style={{
      marginBottom: 8
    }}>
      <LoginButton mdxType="LoginButton" />
    </div>
    <WithUser mdxType="WithUser" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      